export default {"src":"/_next/static/media/main-logo.d1b35a2c.svg","height":24,"width":81,"blurWidth":0,"blurHeight":0};